export default __webpack_public_path__ + "b7e5eff152eb0febbfae3e8a735763023aac9455/45b3d9bead8ca49501a2a3b80e7cc1ac.png";